import { render } from "./text-admun-animation.vue?vue&type=template&id=81266b8e"
import script from "./text-admun-animation.vue?vue&type=script&lang=js"
export * from "./text-admun-animation.vue?vue&type=script&lang=js"

import "./text-admun-animation.vue?vue&type=style&index=0&id=81266b8e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__